import React, { useState } from "react";

export default function DentalClinicLocations() {
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleCount, setVisibleCount] = useState(8);

const clinics = [
  {
    name: "Experience Health Hub & Flagship Center",
    area: "JP Nagar",
    image: "/images/new-website/clinics/JP-Nagar-flagship.webp",
    link: "https://share.google/18S7NIXTr8TDveFrf",
  },
  {
    name: "Adarsh Palm Retreat",
    area: "Bellandur",
    image: "/images/new-website/clinics/adarsh-palm.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic+at+Adarsh+Palm+Retreat,+Bellandur,+Bangalore&stick=H4sIAAAAAAAA_w3GMQ7CMAwF0AnEMSwkNoaAi1DYWhZGxA1-YreNZIJkgtTzcFJ409ust7uwcIIe-Jwi65hV4iUsJ3QSmIPko4ypi99VP3iRSemmsDbT1UotmdCoF_h7pjvsSQ9trmh7GtQMVT7-L-oEe7n-ALs7-6VtAAAA&hl=en&mat=CavVp56QTpmIElcBa0lj_-QC2_RPRxG4TVLY_WuHQBJZqnkqMiyCbuLhWLRNeZYOZ62_w3XGuzdYPGZP3QnhXWrs-8GsJd2Sl8EYwUVueLnHxe_jlsRNzwyGxyhgyw09ISw&authuser=1",
  },
  {
    name: "Bhartiya City",
    area: "Thanisandra",
    image: "/images/new-website/clinics/bharatiya-city.webp",
    link: "https://share.google/NGL89hP4aGmuy2pGP",
  },
  {
    name: "Brigade Meadows",
    area: "Kanakapura Road",
    image: "/images/new-website/clinics/brigade-meadows.webp",
    link: "https://www.google.com/search?q=bridge+health+clinic+brigade+meadows&sca_esv=58d82e2bbc70543a&hl=en&authuser=1&biw=1336&bih=623&sxsrf=APpeQntcJ4wcfQ1TsCjiH0yf5j0LviUq1w%3A1781897881577&ei=mZo1aoHnIsHF4-EPt9akMA&oq=bridge+health+clinic%3A+brigade&gs_lp=Egxnd3Mtd2l6LXNlcnAiHWJyaWRnZSBoZWFsdGggY2xpbmljOiBicmlnYWRlKgIIADIGEAAYFhgeMgYQABgWGB4yCxAAGIAEGIoFGIYDMggQABiABBiiBDIIEAAYgAQYogQyCBAAGIAEGKIEMggQABiJBRiiBDIFEAAY7wVIoRVQAFjFC3AAeAGQAQCYAd0BoAHyBqoBBTAuNi4xuAEByAEA-AEBmAIHoAKuB8ICBRAAGIAEwgIIEAAYFhgeGAqYAwCSBwUwLjYuMaAHjS-yBwUwLjYuMbgHrgfCBwUyLTYuMcgHLYAIAQ&sclient=gws-wiz-serp",
  },
  {
    name: "Ferns City",
    area: "Doddanekkundi",
    image: "/images/new-website/clinics/whitefield-hub.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic+at+Ferns+City,+Doddanekkundi&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1NDRNNjIxSDI1TTS1MqhIMTFNtEhJTUo0Nze0MDQyWsRq6FSUmZKequCRmphTkqHgnJOZl5mskFii4JZalFes4JxZUqmj4JKfkpKYl5qdXZqXkgkASrdqgF0AAAA&hl=en&mat=CfiyHXUU_4qRElcBa0lj_0uNtMylx5dzr3b9l1P2UZR9ki6mdYE9TUvcRmWm1qNi1X5goYlcHY3_0pZ6wHPrLK4zYtgcBOcw4enhdf5V682ZPrZVyoiO-WPuKAs3u4ZwIDs&authuser=1",
  },
  {
    name: "L&T Raintree Boulevard",
    area: "Hebbal",
    image: "/images/new-website/clinics/raintree-clinic.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic+%26+Pharmacy:+L%26T+Raintree+Boulevard+(Tower+17)&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1tDRNszRPNTBNtUizMqiwtLQ0sDSyMEs0MzQzSU5KWsTq5FSUmZKequCRmphTkqHgnJOZl5msoKYQkJFYlJuYXGml4KMWohCUmJlXUpSaquCUX5qTWpZYlKKgEZJfnlqkYGiuCQB0Ba4ibgAAAA&hl=en&mat=CQ6qXJc8Bpk0ElcBa0lj_6v9_HUoYL2Gc4q5hOIg4RaTnhjntPJqjlmk_j45I-H3ul9jVrS5j5sYPtT-udHHre-vqQnPCVqUZyyDydBscVUINXuzwtis-Jc6wTSCdQnTPL0&authuser=1",
  },
  {
    name: "Mantri Tranquil",
    area: "Kanakapura Road",
    image: "/images/new-website/clinics/mantri-tranquil.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic:+Mantri+Tranquil,+Gubbalala,+Subramanyapura+Road&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1Tks0MDA3NEk0S0mzMqhISrOwsDAzTjQ1MDVONU-0WMTq6lSUmZKequCRmphTkqHgnJOZl5lspeCbmFdSlKkQUpSYV1iamaOj4F6alJSYA4Q6CsGlSUWJuYl5lYkFpUWJCkH5iSkA6FfI2XEAAAA&hl=en&mat=CXpid1AuU_5EElcBa0lj_9bc2eeV4fE3Nvarysipi9s3HWttwRCUaQBAU3K5kCKDhaTAkwLWS0AazNjSnZGs6wzu29KGJK0wjB43uh9HZ1S4D58hnHIEzxLWuceKMynasK0&authuser=1",
  },
  {
    name: "Pebble Bay",
    area: "Hebbal",
    image: "/images/new-website/clinics/pebble-bay-clinic.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic:+Pebble+Bay+(Tower+5)&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1NE9NTktKMTQ0MU2yMqhINkw0T7VMtki1MDRITDUxWcSq5VSUmZKequCRmphTkqHgnJOZl5lspRCQmpSUk6rglFipoBGSX55apGCqCQBX18-tVgAAAA&hl=en&mat=CepwEqRlo8nKElcBa0lj_xAIpNzws2oD6nHb28Cyat3aeP8Ynm-tZVJluhi8VSSE3q1pE6RpixjiyaJdMufji_8URl0GzlE1bPrag9HfU14yRsz4S5gRmIVSojqdyQp_x2s&authuser=1",
  },
  {
    name: "Phoenix One",
    area: "Hebbal",
    image: "/images/new-website/clinics/phoenix-one.webp",
    link: "https://www.google.com/search?q=Tower+7,+Phoenix+One+Bangalore+West&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1TrE0sLCwTLVMSUyzAgqZJZtYJhulmiYaGViYW5gtYlUOyS9PLVIw11EIyMhPzcusUPDPS1VwSsxLT8zJL0pVCE8tLgEAFOoSCU8AAAA&hl=en&mat=CaJXA5GHcDx0ElcBa0lj_50x-h3Uh9inv9ljW5x3SMq8Ojz0RvwXA9iRTHVOoev0NO4AEOU4YddlReuVD_ZYHsKecoKCen6-anO_FYlTqWra-eUplWX6VcB7AIy_fYacerU&authuser=1",
  },
  {
    name: "Prestige Golfshire",
    area: "Nandi Hills Road",
    image: "/images/new-website/clinics/prestige-golfshire.webp",
    link: "https://www.google.com/search?q=Bridge+Health:+Prestige+Golfshire&stick=H4sIAAAAAAAA_-NgU1I1qDBOSjJMNU42TTI3TzZNSzK0MqgwtDA0NLdINjE3tUyyNDU0XsSq6FSUmZKequCRmphTkmGlEFCUWlySCRRwz89JK87ILEoFAFAQQ0dNAAAA&hl=en&mat=CaFxZexQOw0hElYBa0lj_xLh8wDC4jTm_aslm1GP-chEhRbUHKOWB9KEgYlH31gOd0JlDfSRMrpVsN4s7_d8l82qtHVS8DOgyBgJlw_uxQytFxN-3IV5Zsx_vg_Nfg7TCg&authuser=1",
  },
  {
    name: "Prestige Jindal City",
    area: "Tumkur Road",
    image: "/images/new-website/clinics/prestige-jindal-city.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic+%26+Pharmacy+at+Prestige+Jindal+City,+Tumkur+Road&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1MjawSEpLMzNPNEiyMqiwMDU0N0tOTU0ysjQ1TDQ0X8Tq4lSUmZKequCRmphTkqHgnJOZl5msoKYQkJFYlJuYXKmQWKIQUJRaXJIJVOSVmZeSmKPgnFlSqaMQUpqbXVqkEJSfmAIAbzgC7HAAAAA&hl=en&mat=CZ1JWk7oUhU1ElYBa0lj_4UnMaPLoKxSQ8qMN9TiZ4afSFfqytp6OxBnRR18POTyCB-to_Td5Q2Xg3pCH5M5Vfd3OfoTSG3fKMGDCxKPtbqKJ1wpz_lyjMOPFQx6Iwa-Sg&authuser=1",
  },
  {
    name: "Prestige Royale Garden",
    area: "Yelahanka",
    image: "/images/new-website/clinics/prestige-royale-garden.webp",
    link: "https://www.google.com/search?q=bridge+health+clinic%3A+prestige+royale+gardens&sca_esv=58d82e2bbc70543a&hl=en&authuser=1&biw=1336&bih=623&sxsrf=APpeQntTD6I1tWywjNCa9ZwCE1IIACJo-g%3A1781897735364&ei=B5o1auviFZiK4-EP1bGK4Ac&ved=0ahUKEwirgqushpSVAxUYxTgGHdWYAnwQ4dUDCBM&uact=5&oq=bridge+health+clinic%3A+prestige+royale+gardens&gs_lp=Egxnd3Mtd2l6LXNlcnAiLWJyaWRnZSBoZWFsdGggY2xpbmljOiBwcmVzdGlnZSByb3lhbGUgZ2FyZGVuczIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIXEC4Y3AYYuAYY2gYY2AIYyAMYsAPYAQEyFxAuGNwGGLgGGNoGGNgCGMgDGLAD2AEBSNQCUABYAHABeAGQAQCYAQCgAQCqAQC4AQPIAQCYAgGgAg6YAwCIBgGQBgq6BgQIARgZkgcBMaAHALIHALgHAMIHAzMtMcgHDIAIAQ&sclient=gws-wiz-serp",
  },
  {
    name: "Prestige Finsbury Park - Hyde",
    area: "Aerospace Park, KIADB",
    image: "/images/new-website/clinics/prestige-finsbury-hyde.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinc:+Prestige+Finsbury+Hyde&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1TDI0NkxMNLI0SE6yMqgwTLJIMwVyDVITk0zMDS0XsWo7FWWmpKcqeKQm5pRkKDjnZOYlWykEFKUWl2QChd0y84qTSosqFTwqU1IBEJJpN1cAAAA&hl=en&mat=Cf7HmrYvcsmqElcBa0lj_2fQNKMPnt7tqciW8gpYwGuPTqbz77xaGsfikfNNQ_b0GuJgX1R2_lFH3l5jaRSMUJiWMwdW0rLxYA4cU8fb23LLAsJtaCwD1byIIwflEERMZuo&authuser=1",
  },
  {
    name: "Prestige Finsbury Park - Regent",
    area: "Aerospace Park, KIADB",
    image: "/images/new-website/clinics/prestige-finbury-park-regent.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic+at+Prestige+Finsbury+Regent+(Near+Clubhouse),+Bagalur&stick=H4sIAAAAAAAA_w3KwQrCMAwA0JPiZwRBUPCQqizocYKIBxH_INmyrlAqpC3M3_FL3fm91XK9wekorE6wcXTGU-fkgtOA_UANiQiTOzj6LR6thd4r3JVjGeEaQwodcIGXaS5hlltIWap94a1eU4HtU9nmWGX81Ky7PbTsOVb7A-7XAXJ2AAAA&hl=en&mat=CbyZRQPiscOeElcBa0lj_-HLSjMP5KZqq3F8bRZ3j_JkveDmmdfuv53vwP35LLolOCfx6qd6KKC5CzF1FkiPaJzFJYI-kVudr-xMatftHgjTAFVvAOhIV5FIlwZbmAwtybo&authuser=1",
  },
  {
    name: "Prestige Sunrise Park Norwood",
    area: "Electronic City",
    image: "/images/new-website/clinics/PSP-Northwood.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic+%26+Pharmacy+at+Prestige+Norwood+(Near+Club+House),+Electronic+City&stick=H4sIAAAAAAAA_xXLsQrCMBAA0EnxMw5BUXAI0dbgaBE6lU7ul7vTBqKBa4rt7_il1v291XK9MePRo5RsPZ_ZWXJ8MWMphi0WhM66x4mK7-J-1cBPgVow5g6qGN6BYAtth_pCmgAztCp9DjNqkn5SYtg1gjrbwUOdhl72B7hFoazpn6uQpx-Hk_1vggAAAA&hl=en&mat=CTLdL-JIoVHAElcBa0lj__dc9-VysOjPZW2VgGyFCkj96kEr2Ff14dGyRijMT7LGKHPOXPj9Lg0IjV7RHQrAdQULEVN9PTGPT3Rx0aSz8K2oJJur80zYi8pYqlyFjQFu054&authuser=1",
  },
  {
    name: "Primus Ohana",
    area: "Sarjapur Road",
    image: "/images/new-website/clinics/primus-ohana.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Health+primus+ohana&sca_esv=ef502ce5d60b7c34&hl=en&authuser=0&sxsrf=APpeQnuJyk4M8VlT_NjUOdwmJohj0asINA%3A1781898065657&ei=UZs1as_bJ_-ZjuMP6eLnwA4&biw=1336&bih=623&ved=0ahUKEwiPyOrJh5SVAxX_jGMGHWnxGegQ4dUDCBI&uact=5&oq=Bridge+Health+Health+primus+ohana&gs_lp=Egxnd3Mtd2l6LXNlcnAiIUJyaWRnZSBIZWFsdGggSGVhbHRoIHByaW11cyBvaGFuYTIFECEYoAFI0xtQAFjrGXAAeAGQAQCYAdQBoAHzD6oBBjAuMTEuMrgBA8gBAPgBAZgCDaACyxDCAgUQABiABMICBhAAGBYYHsICCBAAGBYYHhgKwgICECbCAgsQABiABBiKBRiGA8ICBRAAGO8FwgIIEAAYgAQYogTCAgUQIRifBcICBBAhGBXCAgcQIRgKGKABmAMAkgcGMC4xMS4yoAfNLLIHBjAuMTEuMrgHyxDCBwcwLjguNC4xyAcvgAgB&sclient=gws-wiz-serp",
  },
  {
    name: "Primus Reflection",
    area: "Kanakapura Road",
    image: "/images/new-website/clinics/primus-reflection.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Health+primus+reflection&sca_esv=ef502ce5d60b7c34&hl=en&authuser=0&biw=1336&bih=623&sxsrf=APpeQnuE3GlYygzdCMSMIMAvFTErvxNJLQ%3A1781898107565&ei=e5s1auiLIp6I4-EPp_Sf6Qo&ved=0ahUKEwiotejdh5SVAxUexDgGHSf6J60Q4dUDCBI&uact=5&oq=Bridge+Health+Health+primus+reflection&gs_lp=Egxnd3Mtd2l6LXNlcnAiJkJyaWRnZSBIZWFsdGggSGVhbHRoIHByaW11cyByZWZsZWN0aW9uMgUQIRigATIFECEYoAFI6h5QrgRYnxxwAngBkAEAmAF6oAHVCKoBAzcuNLgBA8gBAPgBAZgCDaACsAnCAgoQABhHGNYEGLADwgIEECEYFZgDAIgGAZAGCJIHAzYuN6AH6h-yBwM0Lje4B58JwgcFMC40LjnIBzKACAE&sclient=gws-wiz-serp",
  },
  {
    name: "Purva Riviera",
    area: "Marathahalli",
    image: "/images/new-website/clinics/purva-rivera.webp",
    link: "#",
  },
  {
    name: "RMZ EcoWorld",
    area: "Bellandur",
    image: "/images/new-website/clinics/ecoworld-clinic.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic:+Ecoworld,+Bellandur&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1NE40TE02MTCySEyyMqgwNDUzNk41tkwzTjRKSzSyXMSq6VSUmZKequCRmphTkqHgnJOZl5lspeCanF-eX5SToqPglJqTk5iXUloEAB5JyvNVAAAA&hl=en&mat=CXYF7ss6kykjElYBa0lj_7DOCcgECiW0iQZxJ8kcqdbl8AXCtILgHc8WgHTtgKGubCOoSC46tzHtClCO2q3XBbatEc5zCAzR6R4tHTUG_Xi0JyqNqtE7NXNng3CnucCvDg&authuser=1",
  },
  {
    name: "Sattva Greenage",
    area: "Hongasandra",
    image: "/images/new-website/dental/BH-sattva-dental.webp",
    link: "https://share.google/DaegklfqHSe6qikLa",
  },
  {
    name: "Sobha City",
    area: "Thanisandra",
    image: "/images/new-website/clinics/sobha-city.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic:+Sobha+City+(Near+Club+House)&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1tDQwTjNJtTBMTjW1MqhISjMwMk9ONDVMNjI3STI1WsRq5FSUmZKequCRmphTkqHgnJOZl5lspRCcn5SRqOCcWVKpoOGXmlgElChNUvDILy1O1QQAzZ89R14AAAA&hl=en&mat=CZANSGcV_-PQElcBa0lj_wG3SrZ7kDyfhe5wrYge-5eqSMpSftD6Dza_OpyUHf-HNrA2V9fquyg81z5lstyJDRCw9ZUktwuqMtDQsvcbDLjeDp3aJoUsaF17jS2wkR6HbDI&authuser=1",
  },
  {
    name: "Sobha Dream Acres",
    area: "Panathur Main Road",
    image: "/images/new-website/clinics/sobha-dream-acres.webp",
    link: "https://www.google.com/search?q=bridge+health+sobha+dream+acres&hl=en&authuser=0&biw=1336&bih=623&sca_esv=ef502ce5d60b7c34&sxsrf=APpeQntCnM2NuT4v9_GIR9LC0veHQRM22Q%3A1781898190267&ei=zps1aoj3D7CT4-EPv93boQs&oq=bridge+health+sobha+dre&gs_lp=Egxnd3Mtd2l6LXNlcnAiF2JyaWRnZSBoZWFsdGggc29iaGEgZHJlKgIIADIFECEYoAEyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGJ8FSK9MUABYpDZwAHgBkAEAmAG8AaAB0wuqAQMyLjm4AQHIAQD4AQGYAgugArQMwgINEAAYgAQYigUYQxjJA8ICChAAGIAEGIoFGEPCAgsQLhiABBjHARivAcICCxAuGK8BGMcBGIAEwgIIEAAYgAQYkgPCAg4QLhiABBjHARivARiOBcICBRAAGIAEwgILEAAYgAQYigUYkQLCAgYQABgWGB7CAggQABgWGB4YCsICCBAAGIkFGKIEwgIIEAAYgAQYogTCAgUQABjvBcICBBAhGBWYAwCSBwQxLjEwoAemWrIHBDEuMTC4B7QMwgcHMC4xLjcuM8gHQoAIAQ&sclient=gws-wiz-serp",
  },
  {
    name: "Vijaya Bank Layout",
    area: "Bilekahalli",
    image: "/images/new-website/clinics/vijaya-bank-colony.webp",
    link: "https://www.google.com/search?q=Bridge+Health+Clinic+%26+Pharmacy:+Vijaya+Bank+Colony&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkw1NElJM01NTTM0MjS1MqhITDQ2TTFPNU42NE41N0myXMRq7FSUmZKequCRmphTkqHgnJOZl5msoKYQkJFYlJuYXGmlEJaZlViZqOCUmJet4Jyfk59XCQC6qq-QXwAAAA&hl=en&mat=CQ8w7BG7-RsYElcBa0lj_zLU-dPiEXVArckX8361jiqj3TMvnQm9vhsSJK28j_tgpDEVUWJ_w2f-WFCKu7E6m4VC8mz8EzBWM8gsSPo71Nko6CFUJ39NNWy8SJd86oeCL6Y&authuser=1",
  },
  {
    name: "Whitefield",
    area: "White Rose Layout",
    image: "/images/new-website/clinics/whitefield-hub.webp",
    link: "https://share.google/6uJlRHZeMdE2vwEWs",
  },
];

  const filteredClinics = clinics.filter((clinic) =>
    `${clinic.name} ${clinic.area} ${clinic.pincode}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const displayedClinics = searchTerm
    ? filteredClinics
    : filteredClinics.slice(0, visibleCount);

  return (
    <section className="dental-location-section">

      <div className="clinic-search">
        <input
          type="text"
          placeholder="Search by clinic name, area or pincode..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="clinic-grid">
        {displayedClinics.map((clinic, index) => (
          <div className="clinic-card" key={index}>
            <img src={clinic.image} alt={clinic.name} />

              <h3>{clinic.name}</h3>

              <div className="clinic-meta">
                <span>{clinic.area}</span>
              </div>

              <a
                href={clinic.link}
                target="_blank"
                rel="noreferrer"
                className="clinic-btn"
              >
                Visit Clinic
              </a>
          </div>
        ))}
      </div>

      {!searchTerm && visibleCount < filteredClinics.length && (
        <div className="load-more-wrap">
          <button
            className="load-more-btn"
            onClick={() => setVisibleCount((prev) => prev + 8)}
          >
            Load More Clinics
          </button>
        </div>
      )}
    </section>
  );
}